export const stripHtmlTags = (str: string) => {
  if (str) {
    return str.replace(/<br \/>/g, '\n').replace(/<[^>]*>?/gm, '');
  }

  return '';
};

// Use after removing markup when HTML-escaped values need to remain readable as plain text.
export const stripHtmlTagsAndDecodeEntities = (str: string): string =>
  stripHtmlTags(str)
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&');

export const stripAllHtmlTags = (str: string) => {
  if (!str) return str;

  return str.replace(/<[^>]*>|&lt;[^&gt;]*&gt;|amp;/gi, '');
};

export const escapeHtmlTags = (str: string) => {
  if (!str) return str;

  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
};
